import { render, staticRenderFns } from "./NewTicketModal.vue?vue&type=template&id=e3fa47a8&scoped=true"
import script from "./NewTicketModal.vue?vue&type=script&lang=js"
export * from "./NewTicketModal.vue?vue&type=script&lang=js"
import style0 from "./NewTicketModal.vue?vue&type=style&index=0&id=e3fa47a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fa47a8",
  null
  
)

export default component.exports